<div class="w-full flex justify-center pt-2 md:pt-3 bg-gray-50 animate-fade-in pl-2">
  @if (items.length > 0) {
  <mat-icon class="text-blue-600 mx-2">history</mat-icon>
  }
  <nav class="w-11/12 flex items-center text-sm" aria-label="History">
    @for (crumb of items; let i = $index; track crumb.url) {
    <a [routerLink]="crumb.url" class="text-blue-600 hover:underline">{{ crumb.label }}</a>
    @if (i < items.length - 1) { <span class="mx-2 text-gray-400">|</span>
      }
      }
  </nav>
</div>